import { TRANSLATIONS_PT_SHELL_AND_COMMON } from "./translations.pt.shell-and-common";
import { TRANSLATIONS_PT_SETTINGS_CORE } from "./translations.pt.settings-core";
import { TRANSLATIONS_PT_SETTINGS_GOOGLE } from "./translations.pt.settings-google";
import { TRANSLATIONS_PT_SETTINGS_MICROSOFT } from "./translations.pt.settings-microsoft";
import { TRANSLATIONS_PT_DOCUMENTS_AND_DRIVE } from "./translations.pt.documents-and-drive";
import { TRANSLATIONS_PT_CHAT_TASKS_AND_PROFILE } from "./translations.pt.chat-tasks-and-profile";
import { TRANSLATIONS_PT_DASHBOARD_AND_KNOWLEDGE } from "./translations.pt.dashboard-and-knowledge";
import { TRANSLATIONS_PT_PLANS_AND_ADMIN } from "./translations.pt.plans-and-admin";
import { TRANSLATIONS_PT_ONBOARDING } from "./translations.pt.onboarding";
import { TRANSLATIONS_PT_GENERATION } from "./translations.pt.generation";
import { TRANSLATIONS_PT_HOME_ACTIONS_AND_OVERVIEW } from "./translations.pt.home-actions-and-overview";
import { TRANSLATIONS_PT_HOME_DECISION_DETAIL } from "./translations.pt.home-decision-detail";
import { TRANSLATIONS_PT_HOME_QUEUE_AND_ACTIVITY } from "./translations.pt.home-queue-and-activity";
import { TRANSLATIONS_PT_HOME_PULSE_AND_CALENDAR } from "./translations.pt.home-pulse-and-calendar";
import { TRANSLATIONS_PT_HOME_QUALITY_AND_ALERTS } from "./translations.pt.home-quality-and-alerts";

export const TRANSLATIONS_PT = {
  ...TRANSLATIONS_PT_SHELL_AND_COMMON,
  ...TRANSLATIONS_PT_SETTINGS_CORE,
  ...TRANSLATIONS_PT_SETTINGS_GOOGLE,
  ...TRANSLATIONS_PT_SETTINGS_MICROSOFT,
  ...TRANSLATIONS_PT_DOCUMENTS_AND_DRIVE,
  ...TRANSLATIONS_PT_CHAT_TASKS_AND_PROFILE,
  ...TRANSLATIONS_PT_DASHBOARD_AND_KNOWLEDGE,
  ...TRANSLATIONS_PT_PLANS_AND_ADMIN,
  ...TRANSLATIONS_PT_ONBOARDING,
  ...TRANSLATIONS_PT_GENERATION,
  ...TRANSLATIONS_PT_HOME_ACTIONS_AND_OVERVIEW,
  ...TRANSLATIONS_PT_HOME_DECISION_DETAIL,
  ...TRANSLATIONS_PT_HOME_QUEUE_AND_ACTIVITY,
  ...TRANSLATIONS_PT_HOME_PULSE_AND_CALENDAR,
  ...TRANSLATIONS_PT_HOME_QUALITY_AND_ALERTS,
};
